import React, { useState } from 'react';
import './NavigationBar.css';
import { navItems } from '../data/navItems';

interface NavigationBarProps {
  onNavigate: (page: string) => void;
  currentPage: string;
}

const NavigationBar: React.FC<NavigationBarProps> = ({ onNavigate, currentPage }) => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  const handleContactClick = (): void => {
    onNavigate('home');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleSubmenuClick = (page: string, sectionId?: string): void => {
    onNavigate(page);
    setOpenDropdown(null);
    if (sectionId) {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <nav className="navigation-bar">
      <div className="nav-container">
        <div className="nav-links">
          {navItems.map((item) => {
            if (item.isContact) {
              return (
                <button
                  key={item.label}
                  className="nav-link contact-btn"
                  onClick={handleContactClick}
                >
                  {item.label}
                </button>
              );
            }

            if (item.subItems) {
              return (
                <div
                  key={item.label}
                  className="nav-dropdown"
                  onMouseEnter={() => setOpenDropdown(item.label)}
                  onMouseLeave={() => setOpenDropdown(null)}
                >
                  <button
                    className={`nav-link ${item.page && currentPage === item.page ? 'active' : ''}`}
                    onClick={() => item.page && onNavigate(item.page)}
                  >
                    {item.label}
                    <span className="dropdown-arrow">▼</span>
                  </button>
                  {openDropdown === item.label && (
                    <div className="dropdown-menu">
                      {item.subItems.map((sub, index) => (
                        <button
                          key={index}
                          className={`dropdown-item ${currentPage === sub.page ? 'active' : ''}`}
                          onClick={() => handleSubmenuClick(sub.page, sub.sectionId)}
                        >
                          {sub.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            return (
              <button
                key={item.label}
                className={`nav-link ${item.page && currentPage === item.page ? 'active' : ''}`}
                onClick={() => item.page && onNavigate(item.page)}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;
